<template>
    <div>
        <div style="display: flex;flex-direction: column;margin-top: 60px;">
            <div class="titlepng"><img src="../assets/jjfa1.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa2.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa3.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa4.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa5.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa6.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa7.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa8.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa9.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa10.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa11.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa12.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa13.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa14.jpg" alt=""></div>
            <div class="titlepng"><img src="../assets/jjfa15.jpg" alt=""></div>

        </div>
        <!-- <div style="display: flex;justify-content: center;"><img src="https://www.tsintell.com/img/yewuxit.jpg" alt="">
        </div>
        <div><img src="https://www.tsintell.com/img/zhuanhuaCG.jpg" alt=""></div>
        <div><img src="https://www.tsintell.com/img/allBH.jpg" alt=""></div>
        <div><img src="	https://www.tsintell.com/img/jiaoS.jpg" alt=""></div>
        <div>
            <h2 class="title">智慧内核</h2>
            <p class="content">
                基于15年积累大数据开发的人工智能模型，对未来个人眼健康发展趋势进行预测与预警建议，对教育单位与行政区域的近视防控工作完成情况进行预测与预警
            </p>
        </div>
        <div style="display: flex;justify-content: center;"><img src="	https://www.tsintell.com/img/yujing.jpg" alt=""></div>
        <div>
            <h2 class="title">智能数据采集终端</h2>
            <p class="content">
                AI智能取代人工数据采集 万能检查设备连接 无线数据传输
            </p>
        </div>
        <div style="display: flex;justify-content: center;"><img src="	https://www.tsintell.com/img/zhongD.jpg" alt="">
        </div> -->
        <Footer />
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
export default {
    components: {
        Footer
    }
}
</script>

<style>
.titlepng{
    display: flex;
    justify-content: center;
}
.title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
}

.content {
    font-size: 16px;
    text-align: justify;
    margin-bottom: 20px;
    justify-content: center;
    display: flex;
}
</style>